import { pgEnum, pgTable, uuid } from "drizzle-orm/pg-core";
import { temporalDate, temporalTimestamps } from "../../utils/sql";
import { user } from "../../auth/core/user.sql";

export const biologicalSex = pgEnum("biological_sex", ["male", "female", "other"]);

// TODO: Rename to userCharacteristic(s?) or userBiology
export const bodyCharacteristic = pgTable("body_characteristic", {
  ...temporalTimestamps,
  userId: uuid("user_id")
    .primaryKey()
    .references(() => user.id),
  biologicalSex: biologicalSex("biological_sex"),
  dateOfBirth: temporalDate("date_of_birth"),
});
